import {commonActions} from '@gisatcz/ptr-state';
import ActionTypes from '../../../../constants/ActionTypes';

export default {
	setActiveKey: commonActions.setActiveKey(
		ActionTypes.WORLD_WATER.WATER_LEVEL.SATELLITES
	),
};
